import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import mspService from '../../services/mspService';

interface MSPProtectedRouteProps {
  children: React.ReactNode;
}

export const MSPProtectedRoute: React.FC<MSPProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  
  // Initialize MSP auth on component mount
  useEffect(() => {
    mspService.initializeAuth();
  }, []);
  
  const isAuthenticated = mspService.isMSPAuthenticated();

  if (!isAuthenticated) {
    // Redirect to MSP login page with return URL
    return <Navigate to="/msp/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};